import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { login } from '../features/authSlice';
import { useNavigate } from 'react-router-dom';
import { Container, Card, Form, Button, Alert } from 'react-bootstrap';
import '../styles/ai-theme.css';

function LoginPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error } = useSelector((state) => state.auth);
  const [form, setForm] = useState({ username: '', password: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await dispatch(login(form));
    if (result.meta.requestStatus === 'fulfilled') navigate('/admin');
  };

  return (
    <div className="ai-scope">
      <div className="ai-bg">
        <div className="center-screen">
          <Container className="card-fixed">
            <Card className="glass-card p-3">
              <div className="glass-header d-flex align-items-center justify-content-between">
                <h4 className="h-title m-0">Admin Login</h4>
                <span className="badge-soft">Secure Access</span>
              </div>
              <div className="p-3">
                <p className="h-subtle mb-3">Sign in with your admin credentials.</p>
                {error && <Alert variant="danger" className="py-2">{error}</Alert>}
                <Form onSubmit={handleSubmit} className="d-grid gap-3">
                  <Form.Group>
                    <Form.Label className="h-subtle">Username</Form.Label>
                    <Form.Control
                      className="input-ai"
                      type="text"
                      required
                      value={form.username}
                      onChange={(e) => setForm({ ...form, username: e.target.value })}
                      placeholder="Enter username"
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label className="h-subtle">Password</Form.Label>
                    <Form.Control
                      className="input-ai"
                      type="password"
                      required
                      value={form.password}
                      onChange={(e) => setForm({ ...form, password: e.target.value })}
                      placeholder="Enter password"
                    />
                  </Form.Group>
                  <Button type="submit" className="btn-ai w-100" disabled={loading}>
                    {loading ? 'Logging in…' : 'Login'}
                  </Button>
                  <Button type="button" className="btn-ai-ghost w-100" onClick={() => navigate('/')}>
                    Back to site
                  </Button>
                </Form>
              </div>
            </Card>
          </Container>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
